<div class="main-content denuncias-dashboard">
  <div class="container-fluid">
    <div class="denuncias-dashboard__shell">
    <section class="dashboard-toolbar">
      <div class="dashboard-toolbar__filters">
        <div class="toolbar-filter">
          <label for="periodo">Periodo</label>
          <div class="toolbar-select">
            <span class="toolbar-select__icon toolbar-select__icon--calendar" aria-hidden="true"></span>
            <select id="periodo" [(ngModel)]="periodoSeleccionado" (ngModelChange)="onPeriodoChange()">
              <option *ngFor="let periodo of periodoList" [ngValue]="periodo.id">
                {{ periodo.nombre }}
              </option>
            </select>
          </div>
        </div>

      </div>

      <div class="dashboard-toolbar__actions">
        <button type="button" class="toolbar-link" (click)="limpiarFiltros()">Restablecer</button>
        <button type="button" class="toolbar-link" (click)="irConfiguracion()">Correos</button>

        <div class="view-switch" aria-label="Cambiar vista">
          <button type="button" class="view-switch__button" (click)="irKanban()">
            <span class="view-switch__icon view-switch__icon--kanban" aria-hidden="true"></span>
            <span>Kanban</span>
          </button>
          <button type="button" class="view-switch__button view-switch__button--active">
            <span class="view-switch__icon view-switch__icon--table" aria-hidden="true"></span>
            <span>Tabla</span>
          </button>
        </div>
      </div>
    </section>

    <section class="dashboard-kpis">
      <article class="dashboard-kpi-card dashboard-kpi-card--total">
        <span class="dashboard-kpi-card__label">Total reportes</span>
        <div class="dashboard-kpi-card__body">
          <strong>{{ dashboard.totalDenuncias || 0 }}</strong>
          <span class="dashboard-kpi-card__meta">Periodo {{ getPeriodLabel().toLowerCase() }}</span>
        </div>
      </article>

      <article class="dashboard-kpi-card dashboard-kpi-card--recibidas">
        <span class="dashboard-kpi-card__label">Recibidas</span>
        <div class="dashboard-kpi-card__body">
          <strong>{{ dashboard.totalRecibidas || 0 }}</strong>
          <span class="dashboard-kpi-card__meta">Nuevos reportes</span>
        </div>
      </article>

      <article class="dashboard-kpi-card dashboard-kpi-card--investigacion">
        <span class="dashboard-kpi-card__label">En investigación</span>
        <div class="dashboard-kpi-card__body">
          <strong>{{ dashboard.totalEnInvestigacion || 0 }}</strong>
          <span class="dashboard-kpi-card__meta">Casos activos</span>
        </div>
      </article>

      <article class="dashboard-kpi-card dashboard-kpi-card--cerradas">
        <span class="dashboard-kpi-card__label">Cerradas</span>
        <div class="dashboard-kpi-card__body">
          <strong>{{ dashboard.totalCerradas || 0 }}</strong>
          <span class="dashboard-kpi-card__meta">Casos resueltos</span>
        </div>
      </article>
    </section>

    <section class="dashboard-insights">
      <article class="dashboard-card dashboard-card--categories">
        <div class="dashboard-card__header">
          <h2>Reportes por Categoría</h2>
          <span class="dashboard-card__dots" aria-hidden="true"></span>
        </div>

        <div class="category-bars" *ngIf="getCategoriaItems().length > 0; else emptyCategoriasTpl">
          <div class="category-bar" *ngFor="let item of getCategoriaItems(); let i = index">
            <div class="category-bar__row">
              <span class="category-bar__label">{{ item.nombre }}</span>
              <span class="category-bar__value">{{ item.total || 0 }} · {{ getCategoriaPercent(item) }}%</span>
            </div>

            <div class="category-bar__track">
              <div class="category-bar__fill" [ngStyle]="getCategoriaBarStyle(item, i)"></div>
            </div>
          </div>
        </div>
      </article>

      <article class="dashboard-card dashboard-card--donut">
        <div class="dashboard-card__header">
          <h2>Distribución por Estado</h2>
        </div>

        <div class="status-donut">
          <div class="status-donut__chart" [ngStyle]="getDonutStyle()">
            <div class="status-donut__center">
              <strong>{{ dashboard.totalDenuncias || 0 }}</strong>
              <span>Total</span>
            </div>
          </div>
        </div>

        <div class="status-legend">
          <div class="status-legend__item" *ngFor="let item of getStatusLegend()">
            <span class="status-legend__dot" [ngClass]="item.className"></span>
            <span class="status-legend__label">{{ item.label }}</span>
            <span class="status-legend__total">{{ item.total }} <small class="status-legend__pct">({{ item.percent }}%)</small></span>
          </div>
        </div>
      </article>
    </section>

    <section class="dashboard-card dashboard-card--table">
      <div class="dashboard-card__header">
        <h2>Reportes Recientes</h2>
        <button type="button" class="toolbar-link toolbar-link--accent" (click)="irKanban()">Ver todos</button>
      </div>

      <div *ngIf="cargando" class="dashboard-loading">Actualizando dashboard...</div>

      <div class="dashboard-table-wrap" *ngIf="!cargando && denuncias.length > 0">
        <table class="dashboard-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Fecha</th>
              <th>Categoría</th>
              <th>Estado</th>
              <th>Prioridad</th>
              <th>Acción</th>
            </tr>
            <tr class="dashboard-table__filters">
              <th>
                <div class="dashboard-filter-field">
                  <i class="material-icons">search</i>
                  <input type="text" class="dashboard-filter" aria-label="Buscar ID" [(ngModel)]="fId"
                    (ngModelChange)="onFiltroTabla()" placeholder="Buscar ID">
                </div>
              </th>
              <th scope="col">
                <div class="dashboard-filter-field">
                  <i class="material-icons">calendar_today</i>
                  <input type="text" class="dashboard-filter" aria-label="Fecha" [(ngModel)]="fFecha"
                    (ngModelChange)="onFiltroTabla()" placeholder="Ej. 24 jun">
                </div>
              </th>
              <th scope="col">
                <div class="dashboard-filter-field">
                  <i class="material-icons">sell</i>
                  <input type="text" class="dashboard-filter" aria-label="Categoría" [(ngModel)]="fCategoria"
                    (ngModelChange)="onFiltroTabla()" placeholder="Categoría">
                </div>
              </th>
              <th scope="col">
                <div class="dashboard-filter-field dashboard-filter-field--select">
                  <i class="material-icons">flag</i>
                  <select class="dashboard-filter" aria-label="Estado" [(ngModel)]="fEstado" (ngModelChange)="onFiltroTabla()">
                    <option [ngValue]="null">Todos</option>
                    <option [ngValue]="1">Recibida</option>
                    <option [ngValue]="2">En investigación</option>
                    <option [ngValue]="3">Cerrada</option>
                  </select>
                </div>
              </th>
              <th scope="col">
                <div class="dashboard-filter-field dashboard-filter-field--select">
                  <i class="material-icons">bolt</i>
                  <select class="dashboard-filter" aria-label="Prioridad" [(ngModel)]="fPrioridad" (ngModelChange)="onFiltroTabla()">
                    <option [ngValue]="null">Todas</option>
                    <option [ngValue]="'Alta'">Alta</option>
                    <option [ngValue]="'Media'">Media</option>
                    <option [ngValue]="'Baja'">Baja</option>
                  </select>
                </div>
              </th>
              <th scope="col"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let denuncia of denunciasPagina()">
              <td class="dashboard-table__id">#{{ denuncia.codigoSeguimiento }}</td>
              <td>{{ denuncia.fechaRegistro | date:'d MMM, y' | titlecase }}</td>
              <td>{{ denuncia.nombreCategoria }}</td>
              <td>
                <span class="dashboard-badge" [ngClass]="getBadgeClass(denuncia.id_estatus)">
                  {{ denuncia.nombreEstatus }}
                </span>
              </td>
              <td>
                <span class="dashboard-priority" [ngClass]="getPriorityClass(denuncia)">
                  <span class="dashboard-priority__dot"></span>
                  <span>{{ getPriorityLabel(denuncia) }}</span>
                </span>
              </td>
              <td>
                <button type="button" class="dashboard-table__action" (click)="verDetalle(denuncia)">
                  Abrir
                </button>
              </td>
            </tr>
            <tr *ngIf="denunciasFiltradas().length === 0">
              <td colspan="6" class="dashboard-table__nomatch">
                No hay reportes que coincidan con los filtros.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="dashboard-pager" *ngIf="!cargando && denuncias.length > 0">
        <div class="dashboard-pager__left">
          <span class="dashboard-pager__info">
            Mostrando {{ rangoInicioTabla() }}–{{ rangoFinTabla() }} de {{ denunciasFiltradas().length }}
          </span>
          <label class="dashboard-pager__size">
            <span>Por página</span>
            <select [(ngModel)]="tamPaginaTabla" (ngModelChange)="onFiltroTabla()">
              <option *ngFor="let t of tamanosPagina" [ngValue]="t">{{ t }}</option>
            </select>
          </label>
        </div>
        <div class="dashboard-pager__controls" *ngIf="totalPaginasTabla() > 1">
          <button type="button" class="dashboard-pager__btn" (click)="primeraPaginaTabla()"
            [disabled]="paginaActualTabla() <= 1" title="Primera página">«</button>
          <button type="button" class="dashboard-pager__btn" (click)="paginaAnteriorTabla()"
            [disabled]="paginaActualTabla() <= 1" title="Página anterior">‹</button>
          <ng-container *ngFor="let p of getPaginationItemsTabla()">
            <button *ngIf="isPageNumber(p)" type="button" class="dashboard-pager__page"
              [class.is-current]="p === paginaActualTabla()" (click)="irPaginaTabla(p)">{{ p }}</button>
            <span *ngIf="!isPageNumber(p)" class="dashboard-pager__ellipsis">…</span>
          </ng-container>
          <button type="button" class="dashboard-pager__btn" (click)="paginaSiguienteTabla()"
            [disabled]="paginaActualTabla() >= totalPaginasTabla()" title="Página siguiente">›</button>
          <button type="button" class="dashboard-pager__btn" (click)="ultimaPaginaTabla()"
            [disabled]="paginaActualTabla() >= totalPaginasTabla()" title="Última página">»</button>
        </div>
      </div>

      <div *ngIf="!cargando && denuncias.length === 0" class="dashboard-empty">
        No hay reportes para los filtros seleccionados.
      </div>
    </section>
    </div>
  </div>
</div>

<ng-template #emptyCategoriasTpl>
  <div class="dashboard-empty dashboard-empty--tight">
    No hay distribución por categoría disponible.
  </div>
</ng-template>
